<template>
    <div class="menu-wrap">
        <ul>
            <li @click="moveMenu('my_coaching')"
            :class="{'active':$router.currentRoute.name=='my_coaching'
                || $router.currentRoute.name=='next_coaching'
                || $router.currentRoute.name=='coaching_request'
                || $router.currentRoute.name=='coaching_message'}">
                <!-- <img src="@/assets/img/my_coaching.svg" alt="HOME" > -->
                <img src="@/assets/img/my_coaching_active.svg" alt="HOME" v-if="$router.currentRoute.name=='my_coaching'
                || $router.currentRoute.name=='next_coaching'
                || $router.currentRoute.name=='coaching_request'
                || $router.currentRoute.name=='coaching_message'">
                <img src="@/assets/img/my_coaching.svg" alt="HOME" v-else>
                <span> my 코칭</span>
            </li>
            <li @click="moveMenu('coaching_journal')" :class="{'active':$router.currentRoute.name=='coaching_journal'
                || $router.currentRoute.name=='client_list'
                || $router.currentRoute.name=='client_detail'
                || $router.currentRoute.name=='recom_video'}">
                <img src="@/assets/img/journal_active.svg" alt="나의 코칭" v-if="$router.currentRoute.name=='coaching_journal'
                || $router.currentRoute.name=='client_list'
                || $router.currentRoute.name=='client_detail'
                || $router.currentRoute.name=='recom_video'">
                <img src="@/assets/img/journal.svg" alt="나의 코칭" v-else>
                <span> 고객/코칭 일지</span>
            </li>
            <li @click="moveMenu('payment_view')" :class="{'active':$router.currentRoute.name=='payment_view'}">
                <img src="@/assets/img/payment.svg" alt="My Info" v-if="$router.currentRoute.name!='payment_view'">
                <img src="@/assets/img/payment_active.svg" alt="My Info" v-else>
                <span> payment</span>
            </li>
            <li @click="moveMenu('myinfo')" :class="{'active':$router.currentRoute.name=='myinfo'}">
                <img src="@/assets/img/info.svg" alt="My Info" v-if="$router.currentRoute.name!='myinfo'">
                <img src="@/assets/img/info_active.svg" alt="My Info" v-else>
                <span> My Info</span>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name:'inc_tab',
        props:{
        },
        watch: {
        },
        mounted(){
        },
        methods:{
            moveMenu(uri){
                this.$router.push({name:uri});
                // location.href=uri;
            }
        }
    }
</script>